<header
  class="toolbar"
  [class.toolbar--live]="facade.mode() === 'live'"
  [class.toolbar--paused]="facade.mode() === 'paused'"
  [class.toolbar--replay]="facade.mode() === 'replay'"
>
  <div class="toolbar__title-group">
    <h1>Human Dome 🛸</h1>

    <div class="toolbar__mode" aria-live="polite">
      <span class="toolbar__mode-dot" aria-hidden="true"></span>
      <div class="toolbar__mode-copy">
        <span class="toolbar__mode-label">{{ facade.modeLabel() }}</span>
        <span class="toolbar__mode-detail">
          {{ facade.apiHealthLabel() }} · Refresh {{ facade.lastRefreshAgeLabel() }}
        </span>
      </div>
    </div>
  </div>

  <div class="toolbar__meta">
    @if (facade.errorMessage(); as message) {
      <span class="toolbar__error">{{ message }}</span>
    }

    @if (facade.detectedDronesErrorMessage(); as droneMessage) {
      <span class="toolbar__error">{{ droneMessage }}</span>
    }

    <div class="toolbar__stat">
      <span>{{ facade.observerCount() }}</span>
      Observations
    </div>

    <div class="toolbar__stat">
      <span>{{ facade.activeDetectedDroneCount() }}</span>
      Drones
    </div>

    <app-settings-menu />

    <button
      class="secondary-button"
      type="button"
      aria-controls="entity-list-panel"
      [attr.aria-expanded]="facade.isEntityListOpen()"
      (click)="facade.toggleEntityList()"
    >
      List
    </button>

    <button
      class="refresh-button"
      type="button"
      [class.refresh-button--stop]="facade.isAutoRefreshEnabled()"
      (click)="facade.toggleRefreshing()"
    >
      {{ facade.isAutoRefreshEnabled() ? 'Stop' : 'Start' }}
    </button>
  </div>
</header>

@if (facade.isReplayActive()) {
  @if (facade.replayCurrentDateTime(); as replayDateTime) {
    <div class="replay-strip">
      <div>
        <span class="replay-strip__label">Replay</span>
        <span>
          {{ replayDateTime | date: 'yyyy-MM-dd HH:mm:ss' }} · {{ facade.replaySpeed() }}x
          @if (facade.isReplayPaused()) {
            · Paused
          }
        </span>
      </div>

      <div class="replay-strip__actions">
        <button class="replay-strip__playback" type="button" (click)="facade.toggleReplayPlayback()">
          {{ facade.replayPlaybackLabel() }}
        </button>

        <button
          class="replay-strip__stop replay-stop-button"
          type="button"
          title="Stop replay and return to the live feed"
          data-tooltip="Returns to live feed"
          (click)="facade.stopReplay()"
        >
          Stop replay
        </button>
      </div>
    </div>
  }
}
